import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Define Colors & Sizes
const COLORS = {
  purple: "#8B5CF6",
  pink: "#EC4899",
  gray: "#9CA3AF",
  black: "#1F2937",
};

const CARD_SIZE = "23rem";


const StyledPortfolio = styled(Box)(({ theme }) => ({
  padding: localStorage.getItem('i18nextLng') === 'en-US' ? '2% 1% 20% 1%' : '2% 17.7% 20% 17.7%',
  // backgroundColor: '#ffffff',
  // display: 'flex',
  background: '#ffffff',
  justifyContent: 'center',
  '& .slick-slide': {
    width: '500px !important',
    margin: '0 18px',
  },
  '& .card-container': {
    '& .MuiPaper-root': {
      borderRadius: 0,
      marginBottom: '50px',
      width: '500px',
      height: '489px',
      borderRadius: '26px',
      justifySelf: 'center'

    },
    '& .cardMedia': {
      // height: '270px',
      width: '500px',
      height: '489px',
    },
  },
  '& .MuiPaper-root': {
    borderRadius: 0,
    marginBottom: '50px',
    width: '500px',
    height: '489px',
    borderRadius: '26px',
    justifySelf: 'center'
  },
  '& .slick-dots': {
    bottom: '-90px !important',
    marginTop: '70px !important',
    'li button:before ': {
      fontSize: '12px'
    }
  },
  '& .cardMedia': {
    height: '489px',
    width: '500px',
  },
  // '& .flickity-page-dots': {
  //   display: 'none',
  // },

  // '& .flickity-enabled': {
  //   outline: 'none',
  // },

  // '& .flickity-button': {
  //   display: 'none',
  // },
  '& .carousel': {
    position: 'relative',
    width: '500px',
    height: `${CARD_SIZE}`,
    perspective: '500px',
    transformStyle: 'preserve-3d',
    justifySelf: 'center'
  },

  '& .card-container': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    transform:
      `rotateY(calc(var(--offset) * 50deg)) 
      scaleY(calc(1 + var(--abs-offset) * -0.4))
      translateZ(calc(var(--abs-offset) * -30rem))
      translateX(calc(var(--direction) * -5rem))`,
    filter: 'blur(calc(var(--abs-offset) * 1rem))',
    transition: 'all 0.3s ease-out',
  },

  '& .card': {
    width: '100%',
    height: '100%',
    padding: '2rem',
    backgroundColor: 'hsl(280deg, 40%, calc(100% - var(--abs-offset) * 50%))',
    borderRadius: '1rem',
    color: `${COLORS.gray}`,
    textAlign: 'justify',
    transition: 'all 0.3s ease-out',

    '& h2': {
      textAlign: 'center',
      fontSize: '2rem',
      fontWeight: 'bold',
      margin: '0 0 0.7em',
      color: `${COLORS.black}`,
    },

    '& p, h2': {
      transition: 'all 0.3s ease-out',
      opacity: 'var(--active)',
    }
  },

  '& .nav': {
    color: 'white',
    fontSize: '5rem',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    zIndex: 2,
    cursor: 'pointer',
    userSelect: 'none',
    background: 'unset',
    border: 'unset',

  },

  '& .left': {
    transform: 'translateX(-700%) translatey(100%)',
    color: '#000000'
  },

  '& .right': {
    right: 0,
    transform: 'translateX(700%) translatey(100%)',
    color: '#000000'
  },

  '& .pageIndicatorContainer': {
    display: 'flex',
    position: 'absolute',
    top: '630px',
    left: '230px',
    '& .pageIndicator': {
      width: '13px',
      height: '13px',
      backgroundColor: '#000',
      borderRadius: '50px',
      marginRight: '10px',
    },
  },

  [theme.breakpoints.down('lg')]: {
  },

  [theme.breakpoints.down('lg')]: {
    // padding: '6% 1% 20% 1%',
    // display: 'none',
    padding: '2% 0 2% 0',
    // '& .slick-slide': {
    //   width: '400px !important',
    //   height: '216px !important',
    //   margin: '0 18px',
    // },
    // '& .MuiPaper-root': {
    //   borderRadius: 0,
    //   marginBottom: '50px',
    //   width: 'unset !important',
    //   height: '391.2px !important',
    //   borderRadius: '26px',
    //   justifySelf: 'center'
    // },
    '& .cardMedia': {
      width: '389px',
      height: '391.2px',
    },
    '& .carousel': {
      position: 'relative',
      width: '80px',
      height: `unset`,
      perspective: '500px',
      transformStyle: 'preserve-3d',
      // height: '36rem !important'
    },

    '& .carousel-status': {
      display: 'none'
    },

    '& .dot': {
      background: '#000 !important',
      opacity: '1 !important',
      boxShadow: 'unset !important',
    },

    '& .dot.selected': {
      background: '#00FF00 !important',
      opacity: '1 !important'
    },

    '& .MuiPaper-root': {
      borderRadius: '20px',
      width: 'unset',
      height: 'unset'
    }
  },
}));

export default StyledPortfolio;
